module.exports = __webpack_public_path__ + "assets/undo.dc50f2d5.svg";